import { WidgetExternalApplicationType } from '../../../../types/widget';
import ExternalApplicationItem from '../components/ExternalApplicationItem';
import ExternalApplicationForm from '../configuration/ExternalApplicationForm';
import { ExternalApplicationDetails, ExternalApplicationType } from '../types/externalApplication';

type N2fFormProps = {
	application: WidgetExternalApplicationType;
	isNew: boolean;
	onSubmit: (application: WidgetExternalApplicationType) => void;
	onRemove: (application: WidgetExternalApplicationType) => void;
};

export const N2fForm = ({ application, isNew, onSubmit, onRemove }: N2fFormProps) => (
	<ExternalApplicationForm application={application} isNew={isNew} onSubmit={onSubmit} onRemove={onRemove} />
);

const N2f = ({ name }: ExternalApplicationType) => (
	<ExternalApplicationItem name={name} imageSrc="/widgets/images/n2f-logo.png" />
);

export const getDetails = ({ name }: Pick<ExternalApplicationType, 'name'>): ExternalApplicationDetails => ({
	name,
	url: `https://auth.n2f.com/fr`,
	component: <N2f name={name} />,
});
